
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#icon-translation_svg__clip0_5816_30432)"}},[_c('path',{attrs:{"d":"M1.696 2.77h13.036v3.661h1.697V1.788a.714.714 0 00-.715-.714h-15A.714.714 0 000 1.788v16.429c0 .395.32.714.714.714h12.143v-1.696H1.697V2.77z"}}),_c('path',{attrs:{"d":"M7.82 4.278H6.466a.183.183 0 00-.17.12L3.46 12.612a.179.179 0 00.17.237h1.23c.075 0 .142-.05.169-.12l.73-2.112h4.38L7.99 4.398a.188.188 0 00-.172-.12zm.276 5.089H6.188l.955-2.764.953 2.764zm11.368.982H16.43V8.273a.18.18 0 00-.179-.178H15a.179.179 0 00-.178.178v2.076h-3.036a.534.534 0 00-.536.536v3.928c0 .297.239.536.536.536h3.036v3.393c0 .098.08.178.178.178h1.25a.18.18 0 00.179-.178v-3.393h3.035a.534.534 0 00.536-.536v-3.928a.534.534 0 00-.536-.536zm-4.642 3.393h-1.965v-1.786h1.965v1.786zm3.57 0H16.43v-1.786h1.964v1.786z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"icon-translation_svg__clip0_5816_30432"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    